import { coreApi, createVenueSpecificClient } from '$api'
import { StaffRole } from '$models'
import {
  hasPermissionsAtVenue,
  singletonQueryClient,
  getCompanyId,
} from '$utils'
// Not from $constants because import cycles can leave it undefined while this file loads
import { PermissionType } from '../../constants/enums'
import sortBy from 'lodash/sortBy'

/** The api will not serve staff roles without this */
const STAFF_ROLE_PERMISSIONS = [PermissionType.Time]

/**
 * Get all Staff Role
 * @param includeDeleted - include the deleted staff roles
 * @param venueId - optional venue ID to fetch roles for specific venue
 * @returns Promise<StaffRole[]>
 */
export const getAll = async (
  includeDeleted: boolean = true,
  venueId?: string
): Promise<StaffRole[]> => {
  if (!hasPermissionsAtVenue(STAFF_ROLE_PERMISSIONS, venueId)) return []

  const client = venueId ? createVenueSpecificClient(venueId) : coreApi
  const companyId = venueId || getCompanyId()

  return singletonQueryClient.fetchQuery({
    queryKey: ['getAllStaffRoles', companyId, includeDeleted],
    queryFn: async () => {
      const roles = await client.getStaffRoles(includeDeleted)
      return sortBy<StaffRole>(roles, 'name')
    },
  })
}
